import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  //首页
  {
    path: "/",
    component: () => import("../layout/home"),
    redirect: "/home",
    meta: { title: "首页" },
    children: [
      // 首页
      {
        path: "home",
        component: () => import("../views/home"),
        meta: { title: "首页" },
      },
      //资讯动态
      {
        path: "newsUpdates",
        component: () => import("../views/newsUpdates"),
        meta: { title: "资讯动态" },
      },
      // 通知公告
      {
        path: "bannerNews",
        component: () => import("../views/bannerNews"),
        meta: { title: "通知公告" },
      },
      // 电子商城
      {
        path: "shop",
        component: () => import("../views/shop"),
        meta: { title: "电子商城" },
      },
      // CA办理
      // {
      //   path: "CAtransact",
      //   component: () => import("../views/CAtransact"),
      //   meta: { title: "CA办理" },
      // },
      // 综合项目管理平台
      {
        path: "Comprehensive",
        component: () => import("../views/Comprehensive"),
        meta: { title: "综合项目管理平台" },
      },
      // 关于我们
      {
        path: "abstract",
        component: () => import("../views/abstract"),
        meta: { title: "关于我们" },
      },
      // 帮助中心
      {
        path: "help",
        component: () => import("../views/help"),
        meta: { title: "帮助中心" },
      },
      {
        path: "helpDetail",
        component: () => import("../views/help/helpDetail.vue"),
        meta: { title: "帮助中心" },
      },
      // //采购公告
      // {
      //   path: "purchase",
      //   component: () => import('../views/purchase'),
      //   meta: { title: '采购公告' }
      // },
      // 详情
      {
        path: "/purchase/info",
        component: () => import("../views/info"),
        meta: { title: "详情" },
      },
      {
        path: "notice",
        component: () => import("../views/notice"),
        meta: { title: "通知公告" },
      },
      // 详情 （新）
      {
        path: "/detail",
        component: () => import("../views/detail"),
        meta: { title: "详情" },
      },
      // 报名
      {
        path: "/purchase/enter",
        component: () => import("../views/enter"),
        meta: { title: "报名" },
      },
      //更正公告
      {
        path: "correct",
        component: () => import("../views/correct"),
        meta: { title: "更正公告" },
      },
      //结果公告
      {
        path: "result",
        component: () => import("../views/result"),
        meta: { title: "结果公告" },
      },
      //公司简介
      {
        path: "abstract",
        component: () => import("../views/abstract"),
        meta: { title: "公司简介" },
      },
      {
        path: "user",
        component: () => import("../layout/user"),
        meta: { title: " 个人中心" },
        // redirect: 'project',
        children: [
          {
            path: "project",
            component: () => import("../views/meproject"),
            meta: { title: "我的项目", auth: true },
          },
          {
            path: "info",
            component: () => import("../views/meinfo"),
            meta: { title: "账户信息", auth: true },
          },
        ],
      },
    ],
  },
  {
    path: "/register",
    component: () => import("../views/register"),
  },
  {
    path: "/login",
    component: () => import("../views/login"),
  },
  {
    path: "/choice",
    component: () => import("../views/choice"),
    meta: { title: "登录" },
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   console.log('to, from, next', to, from, next);
//   const userInfo = localStorage.getItem("userInfo");
//   if (to.path === "/choice" || to.path === "/login") {
//     next();
//   } else {
//     if (userInfo) {
//       console.log(11111);
//       next();
//     } else {
//       console.log(22222);
//       next({ path: "/choice" });
//     }
//   }
// });

export default router;
